<div class="container">
  @if (error() != null) {
    <div class="banner-error">{{ error() }}</div>
    <button class="btn btn-primary btn-assessor" routerLink="/contact/assessor/7">Get support</button>
  } @else {
    <h2>If you are not automatically transferred to the signature page, please click the button below</h2>
    <button class="btn btn-primary btn-assessor" (click)="handleReroute()">Click here</button>
  }
</div>
